import React from "react";
import { Container, Accordion, Row, Col } from "react-bootstrap";
import "./FAQ.scss";

const FAQPage = () => {
  const faqData = [
    {
      question: "Can I bring my own model, or use an existing API Key?",
      answer: "Yes you can"
    },
    {
      question: "Can we deploy it in a way that my code doesn’t go out of my control?",
      answer: "Yes, the “direct” modality with self hosted open source LLMs is the way to go however the infrastructure cost would be high"
    },
    {
      question: "Which Languages are supported?",
      answer: "All major programming languages and platforms are supported."
    },
    {
      question: "What is the accuracy of these conversions?",
      answer: "Conversion accuracy varies based on the programming languages, and platforms between 40-60%. Human in the loop is always required for verification."
    },
    {
      question: "What is the SLA for this service?",
      answer: "CodeCrafter platform supports 99% SLA. The model SLA depends on the hyperscaler provided SLAs which vary."
    },
    {
      question: "Can I use a private OSS LLM in managed model instead of using bedrock, huggingface, or any other hyperscaler?",
      answer: "Yes you can for an additional cost of hosting the OSS LLM on GPUs cluster at a hyperscaler. This also adds additional maintenance cost."
    }
  ];

  return (
    <div className="page-wrapper faq-page">
      <Container fluid>
        <Row>
          <Col>
            <div className="content-wrap">
              <h2 className="page-title">Frequently Asked Questions</h2>
              <div className="faq-wrapper">
                <Accordion>
                  {faqData.map((faq, index) => (
                    <Accordion.Item eventKey={index.toString()} key={index}>
                      <Accordion.Header>{faq.question}</Accordion.Header>
                      <Accordion.Body>{faq.answer}</Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default FAQPage;